/**
 * Utility functions to transform API responses from snake_case to camelCase
 */

/**
 * Transform clinic information from backend format to frontend format
 */
export function transformClinicInfo(apiResponse: any): any {
  if (!apiResponse) return null;
  
  return {
    address: apiResponse.address,
    bucketId: apiResponse.bucket_id,
    clientCode: apiResponse.client_code,
    clientId: apiResponse.client_id,
    clinicId: apiResponse.clinic_id,
    displayName: apiResponse.displayName || apiResponse.display_name,
    location: apiResponse.location,
    name: apiResponse.name,
    orgId: apiResponse.org_id,
    phoneNumber: apiResponse.phoneNumber || apiResponse.phone_number,
    projectId: apiResponse.project_id,
    tenantId: apiResponse.tenantId || apiResponse.tenant_id,
    timezone: apiResponse.timezone,
    email: apiResponse.email,
    logoUrl: apiResponse.logo_url
  };
}

/**
 * Transform payment gateway response from backend format
 */
export function transformPaymentGatewayResponse(apiResponse: any): any {
  if (!apiResponse) return null;
  
  return {
    clientPublicKey: apiResponse.client_public_key,
    apiLoginId: apiResponse.api_login_id
  };
}

/**
 * Generic snake_case to camelCase transformer
 */
export function snakeToCamel(str: string): string {
  return str.replace(/_([a-z])/g, (match, letter) => letter.toUpperCase());
}

/**
 * Generic object transformer from snake_case to camelCase
 */
export function transformObject(obj: any): any {
  if (!obj || typeof obj !== 'object') return obj;
  
  if (Array.isArray(obj)) {
    return obj.map(item => transformObject(item));
  }
  
  const transformed: any = {};
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const camelKey = snakeToCamel(key);
      transformed[camelKey] = transformObject(obj[key]);
    }
  }
  
  return transformed;
}